import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import 'react-phone-input-2/lib/material.css'
import { Grid, MenuItem, FormControl, InputLabel, Select } from '@material-ui/core'

import { fetaures } from '~/constants/data-field'
import { useGrowCropsStore } from '~/store/variety/growcrops'

import { useStyles } from './style'

export const CystNematodeForms: React.FC = () => {
  const classes = useStyles()

  const featuresList = useGrowCropsStore((state) => state.featuresList)

  const arrayFeatures = featuresList.filter((item) => {
    return item.caracteristica === 'CISTO'
  })

  const { control } = useFormContext<any>()

  return (
    <Grid container spacing={3} className={classes.modalStyle}>
      {arrayFeatures?.map((item) => (
        <Grid item sm={6} key={item.id}>
          <Controller
            name={item.raca
              .replace(/\s/g, '')
              .replace('+', 'mais')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()}
            control={control}
            render={({ field }) => (
              <FormControl variant="outlined" className={classes.selectInput}>
                <InputLabel id={`${item.raca.replace(/\s/g, '')}_id`}>{item.raca}</InputLabel>
                <Select
                  {...field}
                  labelId={`${item.raca.replace(/\s/g, '')}_id`}
                  id={item.raca
                    .replace('ç', 'c')
                    .replace(/\s/g, '')
                    .replace('+', 'mais')
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()}
                  label={item.raca}
                  autoWidth
                  defaultValue=""
                >
                  {fetaures.map((Option) => (
                    <MenuItem key={Option.fetauresValue} value={Option.fetauresValue}>
                      {Option.fetauresName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
      ))}
    </Grid>
  )
}
